export enum OrderHistoryPaymentStatusEnum {
  TOTAL = 'TOTAL',
  COMPLETED = 'COMPLETED',
  NOT_PROCESSED = 'NOT_PROCESSED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
  DATA_LOSS = 'DATA_LOSS'
}